/* eslint-disable */
import { useCallback, useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { datadogRum } from '@datadog/browser-rum';
// MSAL imports
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { detectIncognito } from 'detectincognitojs';

import { AppDispatch } from './redux/store';
import indexedDBService from './utils/idb.utils';
import { CustomNavigationClient } from './utils/NavigationClinet';
import {
  MSAL_ENABLED,
  SET_SOCKET_INCOGNITO_URL,
} from './constants/global.constants';
import ChatBot from './components/chatBot/ChatBot';
import ToggleChatButton from './components/toggleChatButton/ToggleChatButton';
import ChatBotWithToggleButton from './components/chatBot/ChatBotWithToggleButton';

import './styles/tailwind.css';
import './App.css';
import { LOAD_EVENTS } from './redux/reducers/eventReducer';
// import FeedbackRating from './components/FeedbackRating/FeedbackRating';
// import ChatBotTemplate from './components/chatBotTemplate/ChatBotTemplate';

type AppProps = {
  pca?: IPublicClientApplication;
};


function App({ pca }: AppProps) {
  const applicationId: string = process.env.REACT_APP_APPLICATION_ID__DATADOGRUM || '';
  const clientToken: string = process.env.REACT_APP_CLIENT_TOKEN_DATADOGRUM || '';
  const environment: string = process.env.REACT_APP_ENV__DATADOGRUM || '';


  const [loadProject, setLoadProject] = useState(false);
  const [displayMessage, setDisplayMessage] = useState<string | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app

  const loadFromIndexedDB = useCallback(async () => {
    try {
      const userNumber = localStorage.getItem('userNumber') as string;
      const events = await indexedDBService.getEventsByUserNumber(userNumber);
      dispatch({ type: LOAD_EVENTS, payload: events });
    } catch (err) {
      console.error('Error fetching data from IndexedDB:', err);
    }
  }, []);

  const purgeEventsExceptForUser = useCallback(async () => {
    const userNumber = localStorage.getItem('userNumber') as string;
    if (!userNumber) return;
    await indexedDBService.purgeEventsExceptForUser(userNumber);
  }, []);



  useEffect(() => {
    loadFromIndexedDB();
    purgeEventsExceptForUser();
  }, [loadFromIndexedDB, purgeEventsExceptForUser]);

  useEffect(() => {
    detectIncognito().then((result) => {
      if (result.isPrivate) {
        SET_SOCKET_INCOGNITO_URL();
      }
      setLoadProject(true);
    });
  }, []);


  if (MSAL_ENABLED && pca) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    return (
      <MsalProvider instance={pca}>
      
        {loadProject && (
          <Routes>
            <Route path="/" element={<ChatBot />} />
            <Route path="/toggle-chat-icon" element={<ToggleChatButton />} />
            <Route path="/chat-bot" element={<ChatBotWithToggleButton />} />
          </Routes>
        )}
      </MsalProvider>
    );
  }
  
  return (
    <>
    
      {loadProject && (
        <Routes>
          <Route path="/" element={<ChatBot />} />
          <Route path="/toggle-chat-icon" element={<ToggleChatButton />} />
          <Route path="/chat-bot" element={<ChatBotWithToggleButton />} />
        </Routes>
      )}
    </>
  );
}

export default App;
